export default {"src":"/_next/static/media/profileActive.fe2d6861.svg","height":14,"width":12,"blurWidth":0,"blurHeight":0};